module.exports = __webpack_public_path__ + "img/trousers-front.17f8a6fe.jpg";